// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { EvidenceOut } from './evidenceOut.zod.ts';
import { NeedMet } from './needMet.zod.ts';
import { ScoresOut } from './scoresOut.zod.ts';

export const matchOutArchivedDefault = false;

export const MatchOut = zod.object({
  "archived": zod.boolean().default(matchOutArchivedDefault),
  "asset_id": zod.uuid(),
  "available_via": zod.union([zod.string(),zod.null()]),
  "evidence": zod.array(EvidenceOut).optional(),
  "gaps": zod.array(zod.string()).optional(),
  "home_country": zod.string(),
  "kind": zod.string(),
  "maturity": zod.string(),
  "measured_or_expected": zod.union([zod.string(),zod.null()]).optional(),
  "name": zod.string(),
  "needs_met": zod.array(NeedMet).optional(),
  "reason": zod.string(),
  "risks": zod.array(zod.string()).optional(),
  "scores": ScoresOut,
  "total": zod.int(),
  "verdict": zod.union([zod.string(),zod.null()]).optional()
});

export type MatchOut = zod.input<typeof MatchOut>;
export type MatchOutOutput = zod.output<typeof MatchOut>;
